import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TitleStrategy } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { environment } from 'src/environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { LoginModule } from './module/login/login.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './shared/interceptors/tokenInterceptor';
import { ApiModule as identityApi } from './api/identity/api.module';
import { ApiModule as ifsApi } from './api/ifs/api.module';
import { ApiModule as passengerApi } from './api/passenger-manifest/api.module';
import { ApiModule as invoiceApi } from './api/invoice/api.module';
import { PaymentHistoryModule } from './module/payment-history/payment-history.module';
import { BrandingTitleStrategy } from './shared/branding/branding-title.strategy';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    PaymentHistoryModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      timeOut: 1000,
    }),
    LoginModule,
    identityApi.forRoot({ rootUrl: environment.apiUrlIdentity }),
    ifsApi.forRoot({ rootUrl: environment.apiUrlIfs }),
    passengerApi.forRoot({ rootUrl: environment.apiUrlPassenger }),
    invoiceApi.forRoot({ rootUrl: environment.apiUrlInvoice }),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: TitleStrategy,
      useClass: BrandingTitleStrategy,
    },
  ],
  bootstrap: [AppComponent],
  exports: [ToastrModule],
})
export class AppModule {}
